import { MarketingHeroContainer } from "../components/MarketingHero/MarketingHeroContainer";
import { MarketingContentContainer } from "../components/MarketingContent/MarketingContentContainer";

export default function MarketingHome() {
  return (
    <>
      <div className="flex flex-col gap-8 py-4">
        <MarketingHeroContainer />
        <MarketingContentContainer />
      </div>
    </>
  );
}
